<template>

    <list-container :name="name">

        <list-nav>
            <list-nav-header title="Scope of Works"></list-nav-header>

            <list-nav-scroll>

                <ul class="hidden-desktop mobile-list-view">
                    <li v-for="item in items">
                        <div class="icon">

                        </div>
                        <div class="info">
                            <span><a :href="item._links.frontend.view">{{ item.title }}</a></span>
                            <span><a :href="item._links.frontend.view">{{ item.reference }}</a></span>
                            <span>{{ item.updated_at }}</span>
                            <span>{{ item.updated_by.name }}</span>
                        </div>
                    </li>
                </ul>

                <table class="responsive-table fix-head hidden-mobile">
                    <thead>
                    <tr>
                        <th scope="col">Reference</th>
                        <th scope="col">Title</th>
                        <th scope="col">Last Updated</th>
                        <th scope="col">Updated By</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="item in items">
                        <td scope="row" data-label="Reference"><a :href="item._links.frontend.view">{{ item.reference }}</a></td>
                        <td data-label="Title"><a :href="item._links.frontend.view">{{ item.title }}</a></td>
                        <td data-label="Last Updated">{{ item.updated_at }}</td>
                        <td data-label="Updated By">{{ item.updated_by.name }}</td>
                    </tr>
                    </tbody>
                </table>

            </list-nav-scroll>
        </list-nav>

    </list-container>
</template>

<script>
    export default {
        props: ['packageId'],
        data() {
            return {
                name: 'sow',
                items: []
            }
        },
        methods: {
            getItems() {
                var that = this;
                var url = appUrls.sow.index;
                var params = {};

                if (this.packageId) {
                    params.package_id = this.packageId;
                }else{
                    console.error('Please provide a valid package id when instantiating this component.');
                    return;
                }

                that.items = [];

                axios.get(url, {params: params})
                    .then(response => {
                        that.items = response.data.data;
                    });
            }
        },
        mounted() {
            var that = this;

            this.getItems();

            window.eventBus.$on('list-view-search-query-changed-' + this.name, _.debounce(function (query) {
                that.search_query = query;
                that.getItems();
            }, 250));


            window.eventBus.$on('sort-widget-sow', function(sortObject){
                that.sort = sortObject;
                that.getItems();
            });

        }
    }
</script>

<style lang="scss">

</style>
